import React from "react"
export default function USA() {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 0H32V24H0V0Z"
        fill="#F7FCFF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 14.668V16.668H32V14.668H0Z"
        fill="#E31D1C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 18.332V20.332H32V18.332H0Z"
        fill="#E31D1C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 7.33203V9.33203H32V7.33203H0Z"
        fill="#E31D1C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 22V24H32V22H0Z"
        fill="#E31D1C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 11V13H32V11H0Z"
        fill="#E31D1C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 0V2H32V0H0Z"
        fill="#E31D1C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 3.66797V5.66797H32V3.66797H0Z"
        fill="#E31D1C"
      />
      <rect width="20" height="13" fill="#2E42A5" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.72123 2.94017L0.995355 3.44906L1.24042 2.54345L0.595703 1.96954H1.43779L1.72022 1.23047L2.05139 1.96954H2.76925L2.20521 2.54345L2.42357 3.44906L1.72123 2.94017ZM5.72123 2.94017L4.99535 3.44906L5.24042 2.54345L4.5957 1.96954H5.43779L5.72022 1.23047L6.05139 1.96954H6.76925L6.20521 2.54345L6.42357 3.44906L5.72123 2.94017ZM8.99535 3.44906L9.72123 2.94017L10.4236 3.44906L10.2052 2.54345L10.7692 1.96954H10.0514L9.72022 1.23047L9.43779 1.96954H8.5957L9.24042 2.54345L8.99535 3.44906ZM13.7212 2.94017L12.9954 3.44906L13.2404 2.54345L12.5957 1.96954H13.4378L13.7202 1.23047L14.0514 1.96954H14.7692L14.2052 2.54345L14.4236 3.44906L13.7212 2.94017ZM0.995355 7.44906L1.72123 6.94017L2.42357 7.44906L2.20521 6.54345L2.76925 5.96954H2.05139L1.72022 5.23047L1.43779 5.96954H0.595703L1.24042 6.54345L0.995355 7.44906ZM5.72123 6.94017L4.99535 7.44906L5.24042 6.54345L4.5957 5.96954H5.43779L5.72022 5.23047L6.05139 5.96954H6.76925L6.20521 6.54345L6.42357 7.44906L5.72123 6.94017ZM8.99535 7.44906L9.72123 6.94017L10.4236 7.44906L10.2052 6.54345L10.7692 5.96954H10.0514L9.72022 5.23047L9.43779 5.96954H8.5957L9.24042 6.54345L8.99535 7.44906ZM13.7212 6.94017L12.9954 7.44906L13.2404 6.54345L12.5957 5.96954H13.4378L13.7202 5.23047L14.0514 5.96954H14.7692L14.2052 6.54345L14.4236 7.44906L13.7212 6.94017ZM0.995355 11.4491L1.72123 10.9402L2.42357 11.4491L2.20521 10.5434L2.76925 9.96954H2.05139L1.72022 9.23047L1.43779 9.96954H0.595703L1.24042 10.5434L0.995355 11.4491ZM5.72123 10.9402L4.99535 11.4491L5.24042 10.5434L4.5957 9.96954H5.43779L5.72022 9.23047L6.05139 9.96954H6.76925L6.20521 10.5434L6.42357 11.4491L5.72123 10.9402ZM8.99535 11.4491L9.72123 10.9402L10.4236 11.4491L10.2052 10.5434L10.7692 9.96954H10.0514L9.72022 9.23047L9.43779 9.96954H8.5957L9.24042 10.5434L8.99535 11.4491ZM13.7212 10.9402L12.9954 11.4491L13.2404 10.5434L12.5957 9.96954H13.4378L13.7202 9.23047L14.0514 9.96954H14.7692L14.2052 10.5434L14.4236 11.4491L13.7212 10.9402ZM16.9954 3.44906L17.7212 2.94017L18.4236 3.44906L18.2052 2.54345L18.7692 1.96954H18.0514L17.7202 1.23047L17.4378 1.96954H16.5957L17.2404 2.54345L16.9954 3.44906ZM17.7212 6.94017L16.9954 7.44906L17.2404 6.54345L16.5957 5.96954H17.4378L17.7202 5.23047L18.0514 5.96954H18.7692L18.2052 6.54345L18.4236 7.44906L17.7212 6.94017ZM16.9954 11.4491L17.7212 10.9402L18.4236 11.4491L18.2052 10.5434L18.7692 9.96954H18.0514L17.7202 9.23047L17.4378 9.96954H16.5957L17.2404 10.5434L16.9954 11.4491ZM3.72123 4.94017L2.99535 5.44906L3.24042 4.54345L2.5957 3.96954H3.43779L3.72022 3.23047L4.05139 3.96954H4.76925L4.20521 4.54345L4.42357 5.44906L3.72123 4.94017ZM6.99535 5.44906L7.72123 4.94017L8.42357 5.44906L8.20521 4.54345L8.76925 3.96954H8.05139L7.72022 3.23047L7.43779 3.96954H6.5957L7.24042 4.54345L6.99535 5.44906ZM11.7212 4.94017L10.9954 5.44906L11.2404 4.54345L10.5957 3.96954H11.4378L11.7202 3.23047L12.0514 3.96954H12.7692L12.2052 4.54345L12.4236 5.44906L11.7212 4.94017ZM2.99535 9.44906L3.72123 8.94017L4.42357 9.44906L4.20521 8.54345L4.76925 7.96954H4.05139L3.72022 7.23047L3.43779 7.96954H2.5957L3.24042 8.54345L2.99535 9.44906ZM7.72123 8.94017L6.99535 9.44906L7.24042 8.54345L6.5957 7.96954H7.43779L7.72022 7.23047L8.05139 7.96954H8.76925L8.20521 8.54345L8.42357 9.44906L7.72123 8.94017ZM10.9954 9.44906L11.7212 8.94017L12.4236 9.44906L12.2052 8.54345L12.7692 7.96954H12.0514L11.7202 7.23047L11.4378 7.96954H10.5957L11.2404 8.54345L10.9954 9.44906ZM15.7212 4.94017L14.9954 5.44906L15.2404 4.54345L14.5957 3.96954H15.4378L15.7202 3.23047L16.0514 3.96954H16.7692L16.2052 4.54345L16.4236 5.44906L15.7212 4.94017ZM14.9954 9.44906L15.7212 8.94017L16.4236 9.44906L16.2052 8.54345L16.7692 7.96954H16.0514L15.7202 7.23047L15.4378 7.96954H14.5957L15.2404 8.54345L14.9954 9.44906Z"
        fill="#F7FCFF"
      />
    </svg>
  )
}
